
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'BalCard',

  props: {
    title: { type: String, default: '' },
    titleTag: { type: String, default: 'h4' },
    square: { type: Boolean, default: false },
    noPad: { type: Boolean, default: false },
    noContentPad: { type: Boolean, default: false },
    noBorder: { type: Boolean, default: false },
    darkBgColor: { type: String, default: '850' },
    imgSrc: { type: String, default: '' },
    hFull: { type: Boolean, default: false },
    growContent: { type: Boolean, default: false },
    rightAlignHeader: { type: Boolean, default: false },
    exposeOverflow: { type: Boolean, default: false },
    overflowYScroll: { type: Boolean, default: false },
    shadow: {
      type: String,
      default: '',
      validator: (val: string): boolean => {
        return ['', 'none', 'sm', 'md', 'lg', 'xl'].includes(val);
      }
    },
    changeType: { type: String, default: '' },
    borderColor: { type: String, default: '' },
    noDataCenter: { type: Boolean, default: false }
  },

  setup(props) {
    const borderClasses = computed(() => {
      if (props.changeType === 'trade') {
        if (props.noBorder) return 'border-none';
        if (props.borderColor) return `border dark:border-${props.borderColor}`;
        return 'border dark:border-gray-1050';
      }
      if (props.changeType === 'createPool') {
        if (props.noBorder) return 'border-none';
        if (props.borderColor) return `border dark:border-${props.borderColor}`;
        return 'border dark:border-gray-1050';
      }
      return 'border dark:border-gray-900';
    });

    const cardClasses = computed(() => {
      return {
        'rounded-lg':
          !props.square && !['trade', 'stake'].includes(props.changeType),
        'overflow-hidden': !props.exposeOverflow,
        [`bg-white dark:bg-gray-${props.darkBgColor}`]: true,
        [`shadow${props.shadow ? '-' : ''}${props.shadow}`]: true,
        [borderClasses.value]: !props.noBorder,
        'h-full': props.hFull,
        rounded: ['trade', 'stake', 'farm'].includes(props.changeType)
      };
    });

    const cardNoDataCls = computed(() => ({
      'justify-center': props.noDataCenter,
      'items-center': props.noDataCenter
    }));

    const headerClasses = computed(() => {
      return {
        'p-4 pb-0': !props.noPad
      };
    });

    const headerFontOpsClasses = computed(() => {
      return {
        'font-ops': !!props.changeType
      };
    });

    const headerContentClasses = computed(() => {
      return {
        'justify-end': props.rightAlignHeader
      };
    });

    const contentClasses = computed(() => {
      return {
        'p-4': !props.noPad && !props.noContentPad,
        'flex-grow': props.growContent
      };
    });

    const footerClasses = computed(() => {
      return {
        'rounded-b-lg': !props.square,
        'p-4 pt-0': !props.noPad
      };
    });

    const featureStyles = computed(() => ({
      backgroundImage: `url('${props.imgSrc}')`
    }));

    return {
      cardClasses,
      contentClasses,
      headerClasses,
      headerContentClasses,
      footerClasses,
      featureStyles,
      headerFontOpsClasses,
      cardNoDataCls
    };
  }
});
